import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	date: {
		id: 'software-burnup-report.grid.date',
		defaultMessage: 'Date',
		description: 'Heading for a table column containing dates',
	},
	event: {
		id: 'software-burnup-report.grid.event',
		defaultMessage: 'Event',
		description: 'Heading for a table column containing events',
	},
	issue: {
		id: 'software-burnup-report.grid.issue',
		defaultMessage: 'Issue',
		description: 'Heading for a table column containing issues',
	},
	completed: {
		id: 'software-burnup-report.grid.completed',
		defaultMessage: 'Completed',
		description:
			'Heading for a table column containing the numeric amount of currently completed work',
	},
	scope: {
		id: 'software-burnup-report.grid.scope',
		defaultMessage: 'Scope',
		description:
			'Heading for a table column containing the numeric amount of currently scoped work',
	},

	estimateUpdated: {
		id: 'software-burnup-report.grid.estimate-updated',
		defaultMessage: 'Estimate updated',
		description: 'Descibes an action performed on an issue',
	},
	issueCompleted: {
		id: 'software-burnup-report.grid.issue-completed',
		defaultMessage: 'Issue completed',
		description: 'Descibes an action performed on an issue',
	},
	issueReopened: {
		id: 'software-burnup-report.grid.issue-reopened',
		defaultMessage: 'Issue re-opened',
		description: 'Descibes an action performed on an issue',
	},
	issueRemoved: {
		id: 'software-burnup-report.grid.issue-removed',
		defaultMessage: 'Removed from sprint',
		description: 'Descibes an action performed on an issue',
	},
	issueAdded: {
		id: 'software-burnup-report.grid.issue-added',
		defaultMessage: 'Added to sprint',
		description: 'Descibes an action performed on an issue',
	},
	sprintStarted: {
		id: 'software-burnup-report.grid.sprint-started',
		defaultMessage: 'Sprint started',
		description: 'Descibes an action performed on a sprint',
	},
	sprintCompleted: {
		id: 'software-burnup-report.grid.sprint-completed',
		defaultMessage: 'Sprint completed',
		description: 'Descibes an action performed on a sprint',
	},

	issueRemovedFromSprint: {
		id: 'software-burnup-report.grid.issue-removed-from-sprint',
		defaultMessage: '(Issue was removed from sprint)',
		description: '',
	},
	scopeArrowLabel: {
		id: 'software-burnup-report.grid.scope-arrow-label',
		defaultMessage: 'To',
		description: 'Accessibility label for estimate change icon in completed and scope cells.',
	},
});
